import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OptionFacetComponentModel } from './option-facet.interfaces';

@Component({
  standalone: false,
    selector: 'faro-option-facet',
    templateUrl: './option-facet.component.html',
    styleUrls: ['./option-facet.component.scss'],
})
export class OptionFacetComponent {
    @Input()
    header?: string;

    @Input()
    collapsed = true;

    @Input()
    facetOptions: OptionFacetComponentModel[] = [];

    @Input()
    selected: OptionFacetComponentModel | undefined | null;

    @Output()
    changed = new EventEmitter<OptionFacetComponentModel>();

    constructor() {}

    notifySelected(option: OptionFacetComponentModel): void {
        if (this.selected !== option) {
            this.selected = option;
            this.changed.emit(this.selected);
        }
    }
}
